/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobQueueResponse {
    getFixupPrototypeFunction() { return BackgroundJobQueueResponse.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobQueueResponse>): BackgroundJobQueueResponse {
        let obj = Object.assign(new BackgroundJobQueueResponse(), model);
        BackgroundJobQueueResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobQueueResponse>): BackgroundJobQueueResponse {
        if (!model) return null;
        return BackgroundJobQueueResponse.newInstance(<BackgroundJobQueueResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobQueueResponse) {
        if (!obj) return;

        models.BackgroundJobQueueResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobQueueResponse): boolean {
        Object.setPrototypeOf(obj, BackgroundJobQueueResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.created) {
            models.RecordIdentity.fixupPrototype(this.created);
        }
        if (this.existing) {
            models.RecordIdentity.fixupPrototype(this.existing);
        }
    }

    /**
     * Background Job that got created
     */
    created: models.RecordIdentity;

    /**
     * Background Job that matched identifier
     */
    existing: models.RecordIdentity;

}
